import type { DemoKey } from '../types';

export const it: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Matematica · Statistica',
  'app.title': 'Statistica',
  'panel.experiment': 'Scena',
  'panel.params': 'Parametri',

  'exp.survey-explorer.title': 'Esploratore di sondaggio',
  'exp.survey-explorer.desc': 'Scegli una colonna; la demo sceglie il riepilogo giusto.',
  'exp.distribution-sculptor.title': 'Scultore di distribuzioni',
  'exp.distribution-sculptor.desc': 'Trascina i punti e osserva come reagiscono le statistiche.',
  'exp.two-variable-lab.title': 'Laboratorio bivariato',
  'exp.two-variable-lab.desc': 'Dispersione, fitting e domanda sulla causalità.',
  'exp.sampling-lab.title': 'Laboratorio di campionamento',
  'exp.sampling-lab.desc': 'Come tecnica e dimensione muovono la media campionaria.',
  'exp.probability-diagrams.title': 'Diagrammi di probabilità',
  'exp.probability-diagrams.desc': 'Vista Venn e albero per eventi composti.',

  'type.qualitative-nominal.label': 'Qualitativo · nominale',
  'type.qualitative-nominal.def': 'Categorie senza ordine intrinseco.',
  'type.qualitative-ordinal.label': 'Qualitativo · ordinale',
  'type.qualitative-ordinal.def': 'Categorie con ordine significativo.',
  'type.qualitative-multi.label': 'Qualitativo · multi-valore',
  'type.qualitative-multi.def': 'Ogni osservazione può avere più etichette.',
  'type.quantitative-discrete.label': 'Quantitativo · discreto',
  'type.quantitative-discrete.def': 'Numeri in passi fissi.',
  'type.quantitative-continuous.label': 'Quantitativo · continuo',
  'type.quantitative-continuous.def': 'Numeri misurati su scala continua.',

  'column.name.label': 'Nome studente',
  'column.height_cm.label': 'Altezza',
  'column.shoe_size_eu.label': 'Numero di scarpe (EU)',
  'column.study_hours.label': 'Ore di studio / settimana',
  'column.test_score.label': 'Voto del test',
  'column.sports_played.label': 'Sport praticati',
  'column.eye_color.label': 'Colore degli occhi',
  'column.commute_min.label': 'Tragitto',
  'column.grade_year.label': 'Classe',
  'column.homework_effort.label': 'Impegno nei compiti',
  'column.ice-cream-sales.label': 'Vendite di gelati',
  'column.drownings.label': 'Annegamenti',
  'column.month.label': 'Mese',
  'column.storks.label': 'Cicogne',
  'column.births.label': 'Nascite',
  'column.country_area_km2.label': 'Superficie del paese',
  'column.sleep_hours.label': 'Ore di sonno',
  'column.reaction_ms.label': 'Tempo di reazione',

  'dataset.master-survey.label': 'Sondaggio di classe',
  'dataset.master-survey.desc': '30 studenti simulati.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Vendite gelati vs annegamenti',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Entrambi salgono e scendono con la stagione. Gli annegamenti non causano le vendite di gelati.',
  'dataset.spurious-storks-vs-births.label': 'Cicogne vs nascite',
  'dataset.spurious-storks-vs-births.desc':
    'Paesi più grandi hanno più cicogne e più nascite. Gli uccelli non sono la causa.',
  'dataset.real-sleep-vs-reaction-time.label': 'Sonno vs tempo di reazione',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Più sonno, reazioni più rapide. Una vera correlazione negativa — con un meccanismo plausibile.',

  'tag.football.label': 'Calcio',
  'tag.basketball.label': 'Pallacanestro',
  'tag.volleyball.label': 'Pallavolo',
  'tag.swimming.label': 'Nuoto',
  'tag.none.label': 'Nessuno',

  'population.gaussian.label': 'Curva a campana',
  'population.right-skewed.label': 'Asimmetrica a destra',
  'population.bimodal.label': 'Bimodale (con strati)',
  'population.uniform.label': 'Uniforme',

  'venn.dice-even-or-prime.label': 'Dado: pari o primo',
  'venn.class-sports-2set.label': 'Sport (2 insiemi)',
  'venn.class-sports-3set.label': 'Sport (3 insiemi)',
  'venn.custom.label': 'Personalizzato',

  'tree.draw-without-replacement.label': 'Estrazione senza reimmissione',
  'tree.custom.label': 'Personalizzato',
  'tree.coin.heads': 'T',
  'tree.coin.tails': 'C',
  'tree.draw.start': 'Sacchetto: 2 rosse, 3 blu',
  'tree.draw.red': 'Rosso',
  'tree.draw.blue': 'Blu',
  'tree.custom.start': 'Inizio',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Istogramma',
  'card.cumulative': 'Frequenza cumulata',
  'card.box': 'Box plot',
  'card.summary': 'Riassunto a 5 numeri',
  'card.bar': 'Grafico a barre',
  'card.mode': 'Moda',
  'card.tag-frequency': 'Frequenza delle etichette',
  'card.mode-tag': 'Etichetta dominante',
  'card.empty-no-order': 'Non applicabile',
  'card.empty-multi': 'Non applicabile',
  'card.numberline': 'Retta numerica',
  'card.scatter': 'Dispersione',
  'card.description': 'Cosa succede',
  'card.population': 'Popolazione',
  'card.sampling-distribution': 'Medie campionarie',
  'card.venn': 'Venn',
  'card.tree': 'Albero',
  'card.probabilities': 'Probabilità',

  'param.dataset.label': 'Dataset',
  'param.column.label': 'Colonna',
  'param.bins.label': 'Intervalli',
  'param.shape.label': 'Forma iniziale',
  'param.show-mean.label': 'Mostra media',
  'param.show-median.label': 'Mostra mediana',
  'param.x-col.label': 'Colonna X',
  'param.y-col.label': 'Colonna Y',
  'param.show-regression.label': 'Retta di regressione',
  'param.show-residuals.label': 'Residui',
  'param.show-confounder.label': 'Mostra confondente',
  'param.population.label': 'Popolazione',
  'param.technique.label': 'Tecnica',
  'param.sample-size.label': 'Dimensione campione',
  'param.stratum.label': 'Strato',
  'param.bias.label': 'Bias',
  'param.mode.label': 'Modalità',
  'param.preset.label': 'Preimpostazione',
  'param.universe.label': 'Dimensione universo',
  'param.show-prob.label': 'Mostra probabilità',
  'param.treat-as-numeric.label': 'Tratta come numerico',

  'stat.count': 'Conteggio',
  'stat.mean': 'Media',
  'stat.median': 'Mediana',
  'stat.range': 'Intervallo',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'Valori anomali',
  'stat.r': 'r di Pearson',
  'stat.r2': 'r²',
  'stat.slope': 'Pendenza',
  'stat.intercept': 'Intercetta',
  'stat.n': 'n',
  'stat.population-mean': 'Media vera',
  'stat.latest-sample-mean': 'Media campionaria',
  'stat.sample-mean-spread': 'DS media campionaria',
  'stat.sample-count': 'Campioni estratti',
  'outlier.upper': 'Anomali superiori',
  'outlier.lower': 'Anomali inferiori',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Ricampiona',
  'btn.run-100': 'Estrai 100 campioni',
  'btn.stop': 'Ferma',
  'btn.clear-history': 'Cancella cronologia',

  'explainer.no-order': 'Senza ordine → niente cumulata, niente box plot.',
  'explainer.multi-no-iqr': 'Multi-valore → quartili / IQR non definiti.',
  'message.no-data': 'Nessun dato.',
  'message.needs-quartiles': 'Servono ≥4 punti per i quartili.',
  'message.x-zero-variance': 'X ha varianza zero — nessuna retta da adattare.',
  'message.n-too-small': 'n troppo piccolo.',
  'message.stratum-clamp': 'Lo strato aveva meno righe del richiesto — usate tutte.',
  'message.siblings-sum-to-one': 'I figli devono sommare a 1.',
};
